// Stepts for homepage
const homepageSteps = [
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: '👋<br>Ahoj, vítej v Onboardiu! ',
        description: 'Průvodce nezabere více než 10 min a můžeš se k němu kdykoli vrátit kliknutím v pravém rohu na loď Onboardio<br>',
        nextBtnText: 'Spustit průvodce',
        position: 'right-center',
        showButtons: true,         // Do not show control buttons in footer
    },
},
// {
//     element: "#start-guide",
//     popover: {
//         title: ' ',
//         description: 'Touto ikonou si můžeš průvodce kdykoli spustit znovu.',
//         position: 'left',
//         showButtons: true,
//     },
// },
{
    element: "#guide-step-hp-1",
    popover: {
        className: 'first-step-popover-class',
        title: 'Proč Onboardio?',
        description: '1.&nbsp;&nbsp;Pomáháme najít ty <b>nejlepší talenty</b><br><br>2.&nbsp;&nbsp;Usnadňujeme komunikaci s uchazeči<br><br>3.&nbsp;&nbsp;<b>Snižujeme fluktuaci</b> zaměstnanců díky<br>&nbsp;&nbsp;&nbsp;&nbsp; osobním stránkám pro nalodění do firmy<br><br>4.&nbsp;&nbsp;Díky vlastním checklistům úkolů<br>&nbsp;&nbsp;&nbsp;&nbsp; <b>už na nic důležitého nezapomenete...</b>',
        position: 'bottom',
        showButtons: true,
    },
    onNext: () => {
        $('#hiring.collapse').collapse('show');

    }
},
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: ' ',
        description: 'Objev, jak ti <b>usnadní práci</b> jednotná správa pracovních pozic a inzerátů (1 min)',
        position: 'right',
        doneBtnText: 'Ano, pokračovat',
        showButtons: true,
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/jobs#guide");

    }
},
]



export default homepageSteps
